module.exports = __webpack_public_path__ + "svg/aoa.a538e06.svg";